import { createRoute } from '@tanstack/react-router';
import { IconFileText } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import './i18n';
import { BlList } from './BlList';
import { BlDetailPage } from './BlDetailPage';
import { BlEditPage } from './BlEditPage';
import { AMENDS, DRAFTS, FINALS, LOIS, MANIFESTS, ORIGINALS, RELEASES } from './fixtures';

const docs: EzyModule = {
  nav: { key: 'docs', label: 'Chứng từ & B/L', icon: IconFileText, section: 'Chứng từ', items: [{ key: 'bl', label: 'Chứng từ & B/L', to: '/ezy/bl' }, { key: 'import', label: 'Hàng nhập & cont', to: '/ezy/import' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/bl', component: BlList }),
    createRoute({ getParentRoute: () => parent, path: '/bl/$id', component: BlDetailPage }),
    createRoute({ getParentRoute: () => parent, path: '/bl/$id/edit', component: BlEditPage }),
  ],
  fixtures: (register) => {
    register('blDraft', DRAFTS);
    register('blFinal', FINALS);
    register('blRelease', RELEASES);
    register('blAmend', AMENDS);
    register('blLoi', LOIS);
    register('blOriginal', ORIGINALS);
    register('blManifest', MANIFESTS);
  },
};
export default docs;
